import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { serviceURLService } from '../service/serviceURL';
import { RouterLink } from '@angular/router';

import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';

@Component({
  selector: 'app-set-profile',
  templateUrl: './set-profile.component.html',
  styleUrls: ['./set-profile.component.css']
})
export class SetProfileComponent implements OnInit {
  data: any ={};
  public showAddFamily: boolean = false;
  public iconVisibility: boolean = false;
  familyMemberName: any;
  familyMemberRelation: any;
  familyMemberDob: any;
  error: any;
  name: string;
  userID: string;
  responseGet: any;
  profileName: any;
  profileContactNo: any;
  profileEmail: any;
  profileDob: any;
  profileCompany: any;
  private onDestroy$: Subject<void> = new Subject<void>();
  
  constructor(private router: Router, private _location: Location, private serviceURLService: serviceURLService) {
    this.name = localStorage.getItem('userID');
   }

  ngOnInit() {
    this.getProfileDetails();
  }

  keyPress(event: any) {
    const pattern = /[0-9\+\-\ ]/;

    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  
  setProfileDetails() {
    this.data.family = [];
    if(this.showAddFamily){
     this.data.family.push({ 
      'relationship': this.familyMemberRelation, 
      'name': this.familyMemberName,
      'dob': (new Date(this.familyMemberDob).getTime())
    });
  }
    //alert(JSON.stringify(this.data));
    this.data = {
      "name":this.data.name,
      "mobile": this.data.mobile,
      "email": this.data.email,
      "dob": (new Date(this.data.dob).getTime()).toString(),
      "company":this.data.company,
      "family": JSON.stringify(this.data.family)
    }
    this.serviceURLService.setProfileDetails(this.data).pipe(takeUntil(this.onDestroy$)).subscribe(successData => {
      console.log("Profile updated Successfully");
      //this.router.navigate(['otp']);
    }, errorData => {
      console.log("not registered");
      if(errorData.error.status === 400){
        this.error = errorData.error.message;
      }
    })

  }


  getProfileDetails() {
    this.userID = localStorage.getItem('userID');
    this.serviceURLService.getProfileDetails(this.userID).pipe(takeUntil(this.onDestroy$)).subscribe((successData:any) => {
      console.log("Registered Successfully");
     this.responseGet = successData.response.profileData;
     this.profileName = successData.response.profileData.name;
     this.profileContactNo = successData.response.profileData.mobile;
     this.profileEmail = successData.response.profileData.email;
     this.profileDob = new Date(successData.response.profileData.dob);
     this.profileCompany = successData.response.profileData.company;
     //console.log("dob", new Date(this.profileDob));
    }, errorData => {
      console.log("not registered");
      if (errorData.error.status === 401) {
        this.router.navigate(['/login']);
        console.log("Please login first");
      } else if (errorData.error.status === 403 || errorData.error.status === 400) {
        this.error = errorData.error.message;
        console.log("ERROR: ",this.error);
      }
    })

  }

  showAddFamilyFunc(){
    this.showAddFamily = true;
 }

  backToReg(){
    this.showAddFamily = false;
  } 

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
